import { render } from "./user_edit.vue?vue&type=template&id=601dced4"
import script from "./user_edit.vue?vue&type=script&lang=js"
export * from "./user_edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__